import { render, staticRenderFns } from "./TablesSettings.vue?vue&type=template&id=789554de&scoped=true&"
import script from "./TablesSettings.vue?vue&type=script&lang=js&"
export * from "./TablesSettings.vue?vue&type=script&lang=js&"
import style0 from "./TablesSettings.vue?vue&type=style&index=0&id=789554de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789554de",
  null
  
)

export default component.exports